// Tiny pub/sub between the realtime stream and the notification island (kept outside React so the
// SSE handler can publish without depending on component state).
import type { AppNotification } from '@mailpilot/shared';

type Listener = (n: AppNotification) => void;
const listeners = new Set<Listener>();

export function emitNotification(n: AppNotification): void {
  listeners.forEach((l) => {
    try {
      l(n);
    } catch {
      /* a broken listener must not break the stream */
    }
  });
}

export function onNotification(l: Listener): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}
